import React, { useEffect, useState } from "react";
import { getSingleOrderDetails } from "../api/orderHistory";
import { useParams } from "react-router-dom";
import Layerzamzam from "../Layerzamzam";
import icon from "../assets/new.png";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import {
  getAddressDropdown,
  getNewShipmentDropdown,
  handleEditedOrder,
  deleteProduct,
} from "../api/createOrder";
import EditSearchableDropdown from "../components/EditSearchable";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { currentLang } from "../../../utility/index";
import { useTranslation } from "react-i18next";
import { useZamzamError } from "../context/ZamzamErrorContext";

type SalesRow = {
  addressId: number;
  orderId: string;
  product_id: string;
  status: string;
  quantity: number;
  deliveryBy: string;
  shippingPoint: string;
  customerId: string;
  is_existing_product:boolean
  inventory: {
    material_desc: string;
    material_desc_ar: string;
    unit_text_ar: string;
    unit_price: string;
    price_with_vat: string;
    available_stock: string;
    unit_text: string;
    is_existing_product: boolean
  }[];
};

type SummesionData = {
  available_stock: number;
  price_with_vat: number;
  unit_price: number;
};

const deliveryOptions = ["NWC", "BERAIN"];

const EditOrderHistory: React.FC = () => {
  const { showError } = useZamzamError();
  const [rows, setRows] = useState<SalesRow[]>([]);
  type NewWarehouseOption = {
    shipmentPointName: string;
    shipmentPointNameArabic: string;
    shipmentPointId: number;
  };

  const navigate = useNavigate();
  const [shippingOptions, setShippingOptions] = useState<NewWarehouseOption[]>(
    []
  );
  const [globalShippingPoint, setGlobalShippingPoint] = useState<string>("");
  const [globalDeliveryBy, setGlobalDeliveryBy] = useState<string>("NWC");
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const [addressOptions, setAddressOptions] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [addressError, setAddressError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingAddresses, setLoadingAddresses] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [orderId, setOrderId] = useState<any>(null);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null
  );
  const [manuallyEnabledRows, setManuallyEnabledRows] = useState<Set<number>>(new Set());

  
  const [cancelReason, setCancelReason] = useState<string>("");
  const [cancelReasonError, setCancelReasonError] = useState<boolean>(false);
  const [language, setLanguage] = useState<string | null>(null);
  const [deleteRequest, setDeleteRequest] = useState<boolean>(false);
  const [summesionData, setSummessionData] = useState<SummesionData>({
    available_stock: 0,
    price_with_vat: 0,
    unit_price: 0,
  });
  const { t } = useTranslation();
  const { id } = useParams();
  const enableDisabledRows = () => {
    const updated = new Set<number>();
    rows.forEach((row, index) => {
      if (!row.is_existing_product) {
        updated.add(index);
      }
    });
    setManuallyEnabledRows(updated);
  };
  
  const deleteProductHandler = async (productId: string) => {
    applyGlobalToRows();

    const payload = {
      addressId: selectedAddress?.toString() || "",
      orderId: id,
      deliveryBy: globalDeliveryBy,
      shippingPoint: globalShippingPoint,
      orderDetails: rows
        .filter((row) => row.quantity > 0)
        .map((row) => ({
          productId: row.product_id,
          quantity: row.quantity,
          ...(row.product_id === selectedProductId && {
            cancel_reason: cancelReason,
          }),
        })),
    };

    try {
      try {
        const response = await deleteProduct(payload);
        if (response.status === 200) {
          toast.success(
            language === "Arabic"
              ? "تم حذف المنتج بنجاح"
              : "Product cancelled successfully"
          );
        } else {
          showError(
            response.data || response,
            language === "Arabic"
              ? "فشل في حذف المنتج"
              : "Failed to delete product"
          );
        }
      } catch (err) {
        console.error("Error deleting product:", err);
        showError(
          err,
          language === "Arabic"
            ? "فشل في حذف المنتج. يرجى المحاولة مرة أخرى."
            : "Failed to delete product. Please try again."
        );
      }
    } catch (err) {
      setError(
        language === "Arabic" ? "فشل في حذف المنتج" : "Failed to delete product"
      );
    } finally {
      setLoadingAddresses(false);
      setDeleteRequest(!deleteRequest);
      setLoading(!loading);
    }
  };

  const handleChange = <K extends keyof SalesRow>(
    index: number,
    field: K,
    value: SalesRow[K]
  ) => {
    setRows((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: field === "quantity" ? Number(value) : value,
      };
      return updated;
    });
  };

  const applyGlobalToRows = () => {
    setRows((prev) =>
      prev.map((row) => ({
        ...row,
        shippingPoint: globalShippingPoint,
        deliveryBy: globalDeliveryBy,
        addressId: selectedAddress ?? 0,
      }))
    );
  };

  const handleSubmit = async () => {
    applyGlobalToRows();

    const payload = {
      addressId: selectedAddress?.toString() || "",
      orderId: id,
      deliveryBy: globalDeliveryBy,
      shippingPoint: globalShippingPoint,
      orderDetails: rows
        .filter((row) => row.quantity > 0)
        .map((row) => ({
          productId: row.product_id,
          quantity: row.quantity,
        })),
    };
    try {
      const response = await handleEditedOrder(payload);
      if (response.status === 200) {
        setTimeout(() => {
          navigate(URL_MAPPING.ORDERHISTORY);
        }, 2000);
        toast.success(
          language === "Arabic"
            ? "تم تعديل الطلب بنجاح"
            : "Order Edited successfully"
        );
      } else {
        showError(
          response.data || response,
          language === "Arabic"
            ? "فشل في تعديل الطلب"
            : "Failed to update order"
        );
      }
    } catch (err) {
      showError(
        err,
        language === "Arabic"
          ? "فشل في تعديل المنتج. يرجى المحاولة مرة أخرى."
          : "Failed to edit product. Please try again."
      );
      setError("Failed to update order");
    } finally {
      setLoadingAddresses(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!id) {
          throw new Error("Order ID is missing");
        }
        const orderRes = await getSingleOrderDetails(id);
        const shipRes = await getNewShipmentDropdown({});
        const defaultShippingPoint =
          shipRes.shipmentPoints?.[0]?.shipmentPointId || "";
        const defaultDeliveryBy = orderRes.data.delivery_by || "";
        setRows(orderRes.data.items);
        setSummessionData(orderRes.data.grand_totals);
        setGlobalShippingPoint(defaultShippingPoint);
        setGlobalDeliveryBy(defaultDeliveryBy);
        setSelectedAddress(orderRes.data.address_id);
        setOrderId(orderRes.data.sap_order_id);
        setShippingOptions(
          shipRes.shipmentPoints.map((point: any) => ({
            shipmentPointName: point.shipmentPointName,
            shipmentPointNameArabic: point.shipmentPointNameArabic,
            shipmentPointId: Number(point.shipmentPointId),
          }))
        );
      } catch (err) {
        console.error("Error fetching data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [deleteRequest]);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const res = await getAddressDropdown({});
        setAddressOptions(res.items);
      } catch (err) {
        setError("Failed to fetch addresses");
      } finally {
        setLoadingAddresses(false);
      }
    };

    fetchAddresses();
  }, []);

  useEffect(() => {
    const lang = currentLang();
    setLanguage(lang);
  }, []);

  return (
    <Layerzamzam>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-lg font-semibold">Edit Order - {id}</h1>
          </div>
          <div className="flex bg-gray-100 p-4 rounded-md mb-6 flex-wrap gap-4">
            <div className="flex flex-col w-[100%] lg:w-[22%]">
              <label className="mb-1 text-sm font-medium text-gray-700">
                {t("createOrder.ShipmentPoint")}
              </label>
              <select
                className="border shadow px-3 py-2 rounded disabled:cursor-not-allowed disabled:bg-[#fff] disabled:text-gray-800"
                disabled
                value={globalShippingPoint}
                onChange={(e) => setGlobalShippingPoint(e.target.value)}
              >
                {shippingOptions.map((opt) => (
                  <option key={opt.shipmentPointId} value={opt.shipmentPointId}>
                    {language === "Arabic"
                      ? opt.shipmentPointNameArabic
                      : opt.shipmentPointName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col w-full sm:w-1/3 -mt-2 lg:w-[22%]">
              <label className="mb-1 text-sm font-medium text-gray-700">
                {t("createOrder.Select_Address")}
              </label>
              <EditSearchableDropdown
                addressOptions={addressOptions}
                selectedAddress={
                  selectedAddress !== null ? String(selectedAddress) : ""
                }
                handleAddressSelectChange={(value) =>
                  setSelectedAddress(value ? Number(value) : 0)
                }
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                loading={loadingAddresses}
                error={error}
                addressError={addressError}
                setAddressError={setAddressError}
                label={false}
              />
            </div>
            <div className="flex flex-col w-full lg:w-[10%]">
              <label className="mb-1 text-sm font-medium text-gray-700">
                {t("createOrder.Delivery_By")}
              </label>
                <select
                className="border shadow px-3 py-2 rounded disabled:cursor-not-allowed disabled:bg-[#fff] disabled:text-gray-800"
                value={globalDeliveryBy}
                onChange={(e) => setGlobalDeliveryBy(e.target.value)}
                disabled
                >
                {deliveryOptions.map((opt) => (
                  <option key={opt} value={opt}>
                  {opt}
                  </option>
                ))}
                </select>
            </div>
            <button
              onClick={enableDisabledRows}
              style={{
              backgroundColor: "#005879",
              height: "40px",
              width: "150px",
              color: "white",
              borderRadius: "5px",
              marginTop: "25px",
              marginLeft: "10px",
              }}
            >
              {t("createOrder.AddProducts")}
            </button>
          </div>
         
          <div className="p-4 overflow-x-auto">
            <table className="w-full border border-gray-300">
              <thead className="bg-[#e8f6fc] text-left">
                <tr>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    {t("createOrder.Product_ID")}
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    {t("createOrder.Description")}
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    {t("createOrder.Unit")}
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    {t("createOrder.Available_Stocks")}
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    <div className="flex items-center space-x-2">
                      <p className="text-xs">{t("createOrder.unitprice")}</p>
                      <img
                        className="cursor-pointer"
                        src={icon}
                        alt="summesion"
                      />
                    </div>
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    <div className="flex items-center space-x-2">
                      <p className="text-xs">{t("createOrder.vat")}</p>
                      <img
                        className="cursor-pointer"
                        src={icon}
                        alt="summesion"
                      />
                    </div>
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    <div className="flex items-center space-x-2">
                      <p className="text-xs">
                        {" "}
                        {t("createOrder.Sales_Quantity")}
                      </p>
                    </div>
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    <div className="flex items-center space-x-2">
                      <p className="text-xs">{t("createOrder.total_price")}</p>
                      <img
                        className="cursor-pointer"
                        src={icon}
                        alt="summesion"
                      />
                    </div>
                  </th>
                  <th
                    className={`px-4 py-3 border ${
                      language ? "rtl text-right" : "text-left"
                    } text-xs font-medium text-black-500`}
                  >
                    <div className="flex items-center space-x-2">
                      <p className="text-xs">{t("createOrder.Actions")}</p>
                    </div>
                  </th>
                </tr>
              </thead><tbody>
              {rows
  .filter((row, index) => row.is_existing_product || manuallyEnabledRows.has(index))
  .map((row, index) => (<tr key={index} className="border-t">
                    <td className="p-2 border text-sm">{row.product_id}</td>
                    <td className="p-2 border text-sm">
                      {language === "Arabic"
                        ? row.inventory[0].material_desc_ar
                        : row.inventory[0].material_desc}
                    </td>
                    <td className="p-2 border text-sm">
                      {language === "Arabic"
                        ? row.inventory[0].unit_text_ar
                        : row.inventory[0].unit_text}
                    </td>
                    <td className="p-2 border text-sm">
                      {Number(
                        row.inventory[0].available_stock
                      ).toLocaleString()}
                    </td>
                    <td className="p-2 border text-sm">
                      {row.inventory[0].unit_price}
                    </td>
                    <td className="p-2 border text-sm">
                      {row.inventory[0].price_with_vat}
                    </td>
                    <td className="p-2 border text-sm">
                      <input
                      type="number"
                      min="0"
                      className="w-full border px-2 py-1"
                      value={row.quantity}
                      disabled={!row.is_existing_product && !manuallyEnabledRows.has(index)}
                      onChange={(e) => {
                        const newQuantity = Number(e.target.value);
                        const availableStock = Number(
                        row.inventory[0].available_stock
                        );
                        if (newQuantity > availableStock) {
                        showError(
                          language === "Arabic"
                            ? "لا يمكن أن تتجاوز الكمية المخزون المتاح"
                            : "Quantity cannot exceed available stock"
                        );
                        return;
                        }
                        handleChange(index, "quantity", newQuantity);
                      }}
                      />
                    </td>
                    <td className="p-2 border text-sm">
                      {(
                        Number(row.inventory[0].price_with_vat) * row.quantity
                      ).toLocaleString()}
                    </td>

                    <td className="p-2 border text-sm">
                    {/* {(row.is_existing_product || manuallyEnabledRows.has(i)) && ( */}
                    {row.quantity > 0 && (
                        <button
                          onClick={() => {
                          setShowDeleteModal(true);
                          setSelectedProductId(row.product_id);
                          }}
                          className="bg-red-500 text-white px-2 py-1 rounded"
                        >
                          {t("createOrder.delete")}
                        </button>
                    )}
                        {/* )} */}
                    </td>

                    {showDeleteModal && (
                      <div className="fixed inset-0 bg-gray-400 bg-opacity-55 border shadow-xl flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded shadow-md w-116">
                          <h2 className="text-sm font-semibold mb-4">
                            {t(
                              "createOrder.Are_you_sure_you_want_to_delete_this_product?"
                            )}
                            <br />
                            #{selectedProductId}
                          </h2>
                          <label className="block mb-2 text-sm font-medium text-gray-700">
                            {t("createOrder.cancel_reason")}
                          </label>
                          {/* <input
                            type="text"
                            className={`w-full border px-3 py-1 rounded ${
                              cancelReasonError ? "border-red-500" : ""
                            }`}
                            value={cancelReason}
                            onChange={(e) => {
                              setCancelReason(e.target.value);
                              setCancelReasonError(false);
                            }}
                          /> */}

<select
        className={`w-full border px-3 py-1 rounded ${cancelReasonError ? "border-red-500" : ""}`}
        value={cancelReason}
        onChange={(e) => {
          setCancelReason(e.target.value);
          setCancelReasonError(false);
        }}
      >
        <option value="">{t("createOrder.select_reason")}</option>
        <option value="44"> {t("createOrder.wrong")}</option>
        <option value="16">{t("createOrder.Customer")}</option>
      </select>
                          {cancelReasonError && (
                            <p className="text-red-500 text-xs mt-1">
                              {t("createOrder.cancel_reason_is_required")}
                            </p>
                          )}
                          <div className="flex justify-end mt-4 gap-2">
                            <button
                              onClick={() => setShowDeleteModal(false)}
                              className="bg-gray-300 text-gray-700 px-3 py-1 rounded"
                            >
                                <span
                                onClick={() => setShowDeleteModal(false)}
                                className="cursor-pointer text-gray-700"
                                >
                             Close
                                </span>
                            </button>
                            <button
                              onClick={() => {
                                if (!cancelReason.trim()) {
                                  setCancelReasonError(true);
                                  return;
                                }
                                if (selectedProductId) {
                                  deleteProductHandler(selectedProductId);
                                } else {
                                  showError(
                                    language === "Arabic"
                                      ? "لم يتم تحديد أي منتج للحذف."
                                      : "No product selected for deletion."
                                  );
                                }
                                setShowDeleteModal(false);
                                setCancelReason("");
                              }}
                              className="bg-[#005879] text-white px-3 py-1 rounded"
                            >
                              {t("createOrder.delete")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </tr>
                ))}
              </tbody>
              <thead className="bg-[#005879] text-left">
                <tr>
                  <th className="p-2 border text-sm"></th>
                  <th className="p-2 border text-sm"></th>
                  <th className="p-2 border text-sm"></th>
                  <th
                    className={`p-2 border text-sm text-gray-100 ${
                      language ? "rtl text-right" : "text-left"
                    }`}
                  >
                    {/* {summesionData?.available_stock.toLocaleString()} */}
                  </th>
                  <th
                    className={`p-2 border text-sm text-gray-100 ${
                      language ? "rtl text-right" : "text-left"
                    }`}
                  >
                    {/* {summesionData?.unit_price} */}
                  </th>
                  <th
                    className={`p-2 border text-sm text-gray-100 ${
                      language ? "rtl text-right" : "text-left"
                    }`}
                  >
                    {/* {summesionData?.price_with_vat} */}
                  </th>
                  <th
                    className={`p-2 border text-sm text-gray-100 ${
                      language ? "rtl text-right" : "text-left"
                    }`}
                  >
                    {rows.reduce((sum, row) => sum + row.quantity, 0)}
                  </th>
                  <th
                    className={`p-2 border text-sm text-gray-100 ${
                      language ? "rtl text-right" : "text-left"
                    }`}
                  >
                    {rows
                      .reduce(
                        (sum, row) =>
                          sum +
                          Number(row.inventory[0].price_with_vat) *
                            row.quantity,
                        0
                      )
                      .toLocaleString()}
                  </th>
                  <th className="p-2 border text-sm text-gray-100"></th>
                </tr>
              </thead>
            </table>
            <div className={`relative flex justify-end px-6 mt-10 mb-6`}>
  <button
    onClick={handleSubmit}
    className="bg-[#005879] text-gray-100 border rounded-md p-2 text-sm w-36"
  >
    {t("createOrder.Update_Order")}
  </button>
</div>

          </div>
        </>
      )}
    </Layerzamzam>
  );
};

export default EditOrderHistory;
